import React, { useState, useEffect, useRef, useMemo } from "react"; // Added hooks
import { CContainer, CRow, CCol } from "@coreui/react"; // Added CRow, CCol
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux"; // Added
import { getOffer } from "src/actions/AllOffersActions"; // Ensure this path is correct
import { imgUrl } from "src/actions/types"; // Ensure this path is correct
import { useSelector } from "react-redux";
import { listBlogs } from "src/actions/blogActions";
import { fetchBlogMetrics } from "src/actions/blogMetricsActions";
import NavStrip from "./section/NavStrip";
import OfferSection from "./section/OfferSection";
import BlogSection from "./section/BlogSection";
import FaqSection from "./section/FaqSection";
import DownloadSection from "./section/DownloadSection";
// --- DRAGGABLE SCROLL HOOK ---

const useDraggableScroll = (ref) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      element.classList.add("active-dragging");
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
      element.style.cursor = "grabbing";
    };

    const handleMouseLeave = () => {
      isDown = false;
      element.style.cursor = "grab";
    };

    const handleMouseUp = () => {
      isDown = false;
      element.classList.remove("active-dragging");
      element.style.cursor = "grab";
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const walk = (x - startX) * 2;
      element.scrollLeft = scrollLeft - walk;
    };

    element.addEventListener("mousedown", handleMouseDown);
    element.addEventListener("mouseleave", handleMouseLeave);
    element.addEventListener("mouseup", handleMouseUp);
    element.addEventListener("mousemove", handleMouseMove);

    return () => {
      element.removeEventListener("mousedown", handleMouseDown);
      element.removeEventListener("mouseleave", handleMouseLeave);
      element.removeEventListener("mouseup", handleMouseUp);
      element.removeEventListener("mousemove", handleMouseMove);
    };
  }, [ref]);
};
const HealthInsurance = () => {
  // const history = useHistory();
  const blogScrollRef = useRef(null);
  useDraggableScroll(blogScrollRef);
  const history = useHistory();
  const dispatch = useDispatch();
  const offerScrollRef = useRef(null);
  const [offers, setOffers] = useState([]);
  const blogs = useSelector((state) => state.blogReducer.blogs || []);
  const doctors = useSelector((state) => state.doctorList?.doctors || []);
  const metrics = useSelector(
    (state) => state.blogMetricsReducer.metrics || {},
  );
  // --- HELPER FUNCTIONS ---
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceFilters, setInsuranceFilters] = useState({
    health: true,
    family: true,
    senior: true,
  });
  const [location, setLocation] = useState("");
  const [query, setQuery] = useState("");

  const toggleInsuranceFilter = (type) => {
    setInsuranceFilters((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching Insurance:", query, location, insuranceFilters);
  };
  const faqData = [
    {
      question: "Can Medisevas HMS, EHR, LMS be accessed on mobile devices?",
      answer:
        "Indeed, Medisevas HMS, EHR, LMS is entirely compatible with mobile devices, enabling healthcare professionals to oversee hospital operations while on the move, thereby guaranteeing uninterrupted connectivity and management from any location.",
    },
    {
      question:
        "Can Medisevas HMS, EHR, LMS be customized for specific healthcare needs?",
      answer:
        "Certainly! Log e Infotech provides affordable HMS, EHR, LMS solutions specifically designed for small healthcare facilities, delivering essential features at a price that meets their requirements.",
    },
    {
      question:
        "What is the difference between on-premise and cloud-based HMS, EHR, LMS?",
      answer:
        "On-premise HMS, EHR, LMS are installed and maintained on the servers of your hospital, whereas cloud-based HMS, EHR, LMS are hosted online, providing flexibility, remote access, and enhanced scalability.",
    },
    {
      question:
        "Which type of training required for Hospital/ Clinical software?",
      answer:
        "Log e Infotech offers comprehensive training programs for hospital and clinical software users, ensuring they are well-equipped to utilize the system effectively. Training can include on-site sessions, webinars, and access to a library of resources and tutorials.",
    },
    {
      question: "Why customization required in Hospital/Clinical Software?",
      answer:
        "Customization is essential in Hospital/Clinical Software to meet the unique needs of each healthcare facility. Every hospital has specific workflows, regulatory requirements, and patient care protocols that must be addressed. Tailoring the software ensures it aligns with these needs, improving efficiency and user satisfaction.",
    },
    {
      question: "Why Healthcare data analysis is important?",
      answer:
        "Healthcare data analysis is crucial for improving patient outcomes, optimizing operational efficiency, and reducing costs. By analyzing data from various sources, healthcare providers can identify trends, make informed decisions, and enhance the quality of care delivered to patients.",
    },
  ];
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const getOfferImage = (offerImage) => {
    if (offerImage && offerImage.trim() !== "") {
      if (offerImage.startsWith("http")) return offerImage;
      const baseUrl = imgUrl.endsWith("/") ? imgUrl.slice(0, -1) : imgUrl;
      const imagePath = offerImage.startsWith("/")
        ? offerImage.slice(1)
        : offerImage;
      return `${baseUrl}/${imagePath}`;
    }
    return "/assets/img/offers/default_offer_image.jpg";
  };

  const truncateDescription = (description, maxLength = 80) => {
    if (!description) return "No description available.";
    const plainText = description.replace(/<[^>]*>/g, "");
    return plainText.length <= maxLength
      ? plainText
      : plainText.substring(0, maxLength) + "...";
  };

  const formatTimeRemaining = (endDate) => {
    if (!endDate) return "Expired";
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    const diffTime = end - new Date();
    if (diffTime <= 0) return "Expired";
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return days > 0 ? `${days} days remaining` : "Ending soon";
  };
  const sortedBlogs = useMemo(() => {
    if (!blogs.length) return [];

    return blogs
      .filter((blog) => blog.status === "published") // सिर्फ पब्लिश हुए लेख
      .map((blog) => {
        const doctor = doctors.find((d) => d.hospitalID === blog.hospitalID);
        const metric = metrics[blog.id] || {};
        return {
          ...blog,
          doctorName: doctor
            ? `Dr. ${doctor.firstName} ${doctor.lastName}`
            : "Admin",
          doctorImage: doctor?.uploadPhoto
            ? `${imgUrl}${doctor.uploadPhoto}`
            : null,
          views: metric.uniqueViewersCount || 0,
          likes: metric.uniqueLikesCount || 0,
        };
      })
      .sort((a, b) => b.views - a.views) // सबसे ज्यादा व्यूज वाले ऊपर
      .slice(0, 6); // सिर्फ टॉप 6 ब्लॉग दिखाएंगे
  }, [blogs, doctors, metrics]);
  // --- FETCH OFFERS ---
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await dispatch(getOffer());
        if (response?.data) {
          // Filter published and active offers
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const valid = response.data.filter((offer) => {
            const end = new Date(offer.endDate);
            return offer.status?.toLowerCase() === "publish" && end >= today;
          });
          setOffers(valid);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchOffers();
  }, [dispatch]);
  useEffect(() => {
    dispatch(listBlogs());
  }, [dispatch]);

  useEffect(() => {
    if (blogs.length > 0) {
      dispatch(fetchBlogMetrics());
    }
  }, [blogs, dispatch]);
  const handleSeeMoreClick = (id) => history.push(`/offer-details#offer-${id}`);
  return (
    <div className="main-page-wrapper">
      <style>
        {`
          /* ==========================================================
   APPOINMENT APP STYLES
   ========================================================== */

:root {
  --primary-color: #0084d9;
  --primary-hover: #0073bf;
  --primary-gradient: linear-gradient(45deg, #0073bf, #0f9dcc);
  --text-dark: #333;
  --text-light: #6c757d;
  --bg-light: #f8f9fa;
  --border-color: #e9ecef;
  --star-color: #f8b400;
  --success-color: #198754;
  --accent-color: #0d622b;
  --accent-hover: #0a5024;
}

.main-page-wrapper {
  width: 100%;
  overflow-x: hidden;
  position: relative;
}

/* ==========================================================
   SECTION STYLES
   ========================================================== */

.section-doctors {
  z-index: 1000 !important;
}

.section-header-doctors h2 {
  font-size: 2rem;
  font-weight: 500;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

.section-header-doctors p {
  font-size: 1rem;
  color: var(--text-light);
  max-width: 500px;
}

.feature-list {
  list-style: none;
  padding-left: 0;
  margin-top: 1.5rem;
}

.feature-list li {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: #495057;
  margin-bottom: 1rem;
}

.feature-list i {
  color: var(--primary-color);
  font-size: 1.1rem;
  margin-right: 12px;
}

.btn-explore-doctors {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  padding: 10px 25px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-explore-doctors:hover {
  background-color: var(--primary-hover);
  border-color: var(--primary-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(20, 190, 240, 0.3);
}

/* ==========================================================
   DOCTOR CARDS
   ========================================================== */

.doctor-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0,0,0,0.07);
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  width: 260px;
  height: 410px;
}

.doctor-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.doctor-card.disabled {
  cursor: default;
  opacity: 0.7;
}

.doctor-card.disabled:hover {
  transform: none;
  box-shadow: 0 6px 20px rgba(0,0,0,0.07);
}

.doctor-card-img-wrapper {
  width: 100%;
  height: 150px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f0f0f0;
}

.doctor-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.doctor-card:hover .doctor-card-img {
  transform: scale(1.1);
}

.availability-badge {
  position: absolute;
  bottom: 1px;
  left: 16px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 4px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

.availability-badge.available {
  background-color: rgba(25, 135, 84, 0.8);
}

.availability-badge.unavailable {
  background-color: rgba(220, 53, 69, 0.8);
}

.doctor-card-content {
  padding: 1rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.doctor-card-body {
  flex-grow: 1;
}

.doctor-card-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.15rem;
  color: var(--text-dark);
}

.doctor-card-title a {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease;
}

.doctor-card-title a:hover {
  color: var(--primary-color);
}

.doctor-card-speciality {
  font-size: 0.85rem;
  color: var(--text-light);
  margin-bottom: 0.75rem;
  font-weight: 500;
}

.doctor-card-stats {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 0.75rem;
  font-size: 0.8rem;
  color: var(--text-light);
}

.doctor-card-stats .rating-stars {
  color: var(--star-color);
}

.doctor-card-stats .recommendation i {
  color: var(--success-color);
}

.doctor-card-stats .stat-divider {
  color: var(--border-color);
  margin: 0 3px;
}

.doctor-card-details {
  list-style: none;
  padding-left: 0;
  font-size: 0.85rem;
  color: #495057;
  margin: 0 0 1rem 0;
}

.doctor-card-details li {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.doctor-card-details li i {
  color: var(--primary-color);
  margin-right: 8px;
  width: 14px;
  text-align: center;
}

.doctor-card-footer {
  display: flex;
  gap: 0.5rem;
  margin-top: auto;
  border-top: 1px solid var(--border-color);
  padding-top: 0.75rem;
}

.doctor-card-footer .btn {
  font-weight: 600;
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 0.60rem;
}

.favourite-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #6c757d;
  transition: all 0.3s ease;
  backdrop-filter: blur(4px);
}

.favourite-btn:hover {
  transform: scale(1.1);
  color: #e44d26;
}

.favourite-btn.favourited {
  color: #e44d26;
}

/* ==========================================================
   DOCTOR FEATURES
   ========================================================== */

.doctor-card-features {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.feature-tag.video-available {
  color: #0d622b;
  border-color: #b6dcfb;
}

.feature-tag.video-unavailable {
  color: #adb5bd;
  border-color: #e9ecef;
  opacity: 0.8;
}

.speciality-logo-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  object-fit: contain;
  flex-shrink: 0;
}

/* ==========================================================
   DOCTORS CAROUSEL
   ========================================================== */

.doctors-carousel-wrapper {
  position: relative;
  padding: 0 10px;
}

.doctors-carousel-arrow {
  background-color: #fff;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 44px;
  height: 44px;
  font-size: 18px;
  color: var(--text-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 10;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  transition: all 0.3s ease;
}

.doctors-carousel-arrow:hover {
  background-color: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color);
}

.doctors-carousel-arrow.left {
  left: -15px;
}

.doctors-carousel-arrow.right {
  right: -15px;
}

/* ==========================================================
   SEARCH SECTION
   ========================================================== */

.section-search {
  position: relative;
  z-index: 0;
  overflow: visible !important;
  // padding: 60px 0;
  background-color: #5EAB87 !important;
  background-image: none !important;
  border-radius: 0 !important;
  color: white !important;
}

/* Background Animations */
.section-search .shape, 
.section-search .dots {
  position: absolute;
  pointer-events: none;
  z-index: 1;
  opacity: 0.2;
  fill: currentColor;
}

.section-search .shape-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -50px;
  animation: shapes-float 4s ease-in-out infinite;
}

.section-search .shape-2 {
  width: 250px;
  height: 250px;
  bottom: -80px;
  left: -50px;
  animation: shapes-float 6s ease-in-out infinite reverse;
}

.section-search .dots-1 {
  width: 150px;
  height: 150px;
  top: 20px;
  left: 15%;
  animation: shapes-float 5s ease-in-out infinite;
}

.section-search .dots-2 {
  width: 150px;
  height: 150px;
  bottom: 40px;
  right: 15%;
  animation: shapes-float 6s ease-in-out infinite reverse;
}

@keyframes shapes-float {
  0%, 100% {
    transform: scale(1) translateY(0) rotate(0deg);
  }
  50% {
    transform: scale(1.1) translateY(-20px) rotate(10deg);
  }
}

/* Search Container */
.custom-search-bar {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 10;
}

/* Filter Badges */
.filter-badge-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

.filter-badge-item {
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 19px;
  font-weight: 700;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none;
  color: #fff;
  gap: 8px;
}

.small-checkbox-box {
  width: 14px;
  height: 14px;
  border: 2px solid #046525;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  flex-shrink: 0;
  margin-top: 5px;
  position: relative;
}

.small-checkbox-box i {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 15px;
  font-weight: 900;
  pointer-events: none;
  text-shadow: 
    1px 1px 0 #fff,
    -1px -1px 0 #fff,
    1px -1px 0 #fff,
    -1px 1px 0 #fff;
}

.service-icon {
  font-size: 12px;
}

.filter-badge-item.active {
  color: #ffffff;
  border-color: #046525;
}

.filter-badge-item.active .small-checkbox-box {
  border-color: #046525;
}

.filter-badge-item.active .small-checkbox-box i {
  color: #ffffff;
  text-shadow: none;
}

/* Desktop Search */
@media (min-width: 992px) {
  .search-container-custom {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid #ffffff !important;
    border-radius: 60px;
    padding: 6px 6px 6px 20px;
    max-width: 800px;
    position: relative;
    z-index: 5;
  }

  .search-input-wrapper {
    position: relative;
    flex-grow: 1;
    margin-right: 10px;
  }

  .search-input-wrapper:last-child {
    margin-right: 0;
  }

  .form-control {
    border: none !important;
    background: transparent !important;
    color: #ffffff !important;
    outline: none;
    font-size: 16px;
    padding-left: 35px !important;
  }

  .input-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.7);
    z-index: 2;
    font-size: 16px;
  }

  .btn-white-download {
    background-color: #ffffff !important;
    color: #5EAB87 !important;
    border-radius: 50px !important;
    border: 2px solid #ffffff !important;
    font-weight: 700 !important;
    white-space: nowrap;
    transition: all 0.3s ease;
    cursor: pointer;
    font-size: 16px;
    width: 130px;
    height: 40px;
  }

  .btn-white-download:hover {
    background-color: #4d9171 !important;
    color: #ffffff !important;
    transform: translateY(-3px);
    border-color: #4d9171 !important;
  }
}

/* Mobile/Tablet Search */
@media (max-width: 991px) {
  .filter-badge-group {
    flex-direction: column;
    align-items: center;
  }

  .filter-badge-item {
    width: fit-content;
    padding: 4px 10px;
    font-size: 10px;
    gap: 6px;
  }

  .small-checkbox-box i {
    top: -7px;
    right: -6px;
    font-size: 15px;
  }

  .cta-container {
    text-align: center;
    padding: 3rem 1.5rem;
  }

  .search-container-custom {
    display: flex;
    flex-direction: column;
    gap: 15px;
    background: transparent !important;
    border: none !important;
    align-items: center !important;
    width: 50%;
  }

  .search-input-wrapper {
    position: relative;
  }

  .form-control {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid #ffffff !important;
    border-radius: 50px !important;
    padding: 15px 20px 15px 50px !important;
    color: white !important;
    text-align: left;
    width: 100%;
    outline: none;
    font-size: 16px;
  }

  .input-icon {
    left: 18px !important;
  }

  .btn-white-download {
    background-color: #ffffff !important;
    color: #5EAB87 !important;
    border-radius: 10px !important;
    width: auto !important;
    font-weight: 700 !important;
    border: 2px solid #ffffff !important;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .section-search .shape, 
  .section-search .dots {
    opacity: 0.07;
  }
}

/* Form Placeholder */
.form-control::placeholder {
  color: rgba(255, 255, 255, 0.85) !important;
}

.form-control-custom::placeholder {
  font-weight: 600 !important;
  color: rgba(255, 255, 255, 0.8) !important;
}

/* ==========================================================
   DROPDOWN STYLES
   ========================================================== */

.custom-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  min-width: 250px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
  z-index: 99999;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin-top: 5px;
  border-radius: 15px;
  background-color: #7BC29C !important;
  border: none !important;
}

.custom-dropdown::-webkit-scrollbar {
  width: 6px;
}

.custom-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.custom-dropdown::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.custom-dropdown::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.custom-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background 0.2s;
  border-bottom: 1px solid #f5f5f5;
  border: none !important;
}

.custom-dropdown-item:last-child {
  border-bottom: none;
}

.custom-dropdown-item:hover {
  background-color: #f0f9ff;
  color: #4d9171 !important;
}

.dropdown-header {
  padding: 8px 20px;
  font-size: 0.75rem;
  font-weight: 900;
  color: rgb(9, 9, 9);
  background-color: #f8f9fa;
  text-transform: uppercase;
}

.item-icon {
  color: #212529;
  width: 18px;
}

.border-separator,
.border-start-desktop {
  border-left: none !important;
  border: none !important;
  display: none !important;
}



/* ==========================================================
   OFFER SECTION - CLEAN VERSION (NO INLINE STYLES)
   ========================================================== */

.offer-section-wrapper {
  margin-bottom: 2rem;
}

.offer-scroll-row {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 20px;
  padding: 25px 15px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  user-select: none;
}

.offer-scroll-row::-webkit-scrollbar {
  display: none !important;
}

.offer-scroll-row.active-dragging {
  cursor: grabbing !important;
}

.offer-scroll-row::-webkit-scrollbar-track {
  background: transparent;
}

/* Offer Card */
.offer-card {
  height: 150px;
  width: 350px;
  flex: 0 0 350px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  border: 1px solid #eee;
  box-shadow: 0 4px 15px rgba(0,0,0,0.06);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  cursor: pointer;
  position: relative;
}

.offer-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  transform: translateY(-6px);
}

/* Left Image Section */
.offer-card-image {
  flex: 0 0 70%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  pointer-events: none;
}

.offer-card-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 3px 6px rgba(0,0,0,0.08));
}

/* Right Stub Section */
.offer-card-stub {
  flex: 0 0 30%;
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  border-left: 2px dashed #e5e5e5;
  position: relative;
}

/* Stub Holes */
.offer-card-stub::before,
.offer-card-stub::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: #f8f9fa;
  border-radius: 50%;
  left: -11px;
  border: 1px solid #eee;
}

.offer-card-stub::before {
  top: -10px;
}

.offer-card-stub::after {
  bottom: -10px;
}

/* Time Remaining Badge */
.offer-time-remaining {
  font-size: 9px;
  color: #f08a24;
  font-weight: 800;
  text-transform: uppercase;
}

/* Offer Title */
.offer-title {
  font-size: 13px;
  font-weight: 700;
  color: #333;
  margin: 6px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
}

/* Offer Description */
.offer-description {
  font-size: 10.5px;
  color: #777;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* See More Link */
.offer-see-more {
  font-size: 11px;
  font-weight: 700;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.offer-see-more:hover {
  color: #0056b3;
}

/* Empty State */
.offer-empty-state {
  text-align: center;
  width: 100%;
  padding: 20px 0;
}

.offer-empty-state p {
  color: #6c757d;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .offer-card {
    width: 300px;
    flex: 0 0 300px;
    height: 130px;
  }
  
  .offer-card-stub {
    padding: 10px 8px;
  }
  
  .offer-title {
    font-size: 12px;
  }
  
  .offer-description {
    font-size: 9px;
  }
}

@media (max-width: 576px) {
  .offer-scroll-row {
    padding: 15px 5px;
    gap: 10px;
  }
  
  .offer-card {
    width: 280px;
    flex: 0 0 280px;
    height: 120px;
  }
}
/* ==========================================================
   BLOG SECTION
   ========================================================== */

.blog-scroll-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 2rem;
  scroll-behavior: smooth;
  padding-bottom: 12px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  WebkitOverflowScrolling: touch;
  cursor: grab;
  user-select: none;
  gap: 15px;
  padding: 10px;
}

.blog-scroll-row::-webkit-scrollbar {
  display: none !important;
}

.blog-card {
  flex: 0 0 calc(50% - 1rem);
  min-width: 260px;
  max-width: 300px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.07);
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 260px;
  min-width: 260px;
  height: 320px;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  background: #fff;
  border: 1px solid #e0e0e0;
  margin: 0 8px;
  overflow: hidden;
  flex: 0 0 auto;
  cursor: pointer;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.blog-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  transform: translateY(-6px);
}

.blog-card-img-top {
  width: 260px;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
  width: 50px;
  height: 40px;
}

@media (max-width: 600px) {
  .blog-card {
    flex: 0 0 97%;
  }
}

@media (max-width: 576px) {
  .blog-card-img-top {
    width: 100%;
    height: auto;
  }
}

.fixed-card-size {
  flex: 0 0 auto;
  width: 320px;
  height: 400px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 6px 20px rgba(0,0,0,0.07);
  margin: 0 10px;
}

.fixed-img-size {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}


/* ==========================================================
   BLOG SECTION - CLEAN VERSION (NO INLINE STYLES)
   ========================================================== */

.blog-section-wrapper {
  margin-bottom: 2rem;
}

.blog-scroll-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 15px;
  padding: 10px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  user-select: none;
}

.blog-scroll-row::-webkit-scrollbar {
  display: none !important;
}

.blog-scroll-row.active-dragging {
  cursor: grabbing !important;
}

/* Blog Card */
.blog-card {
  width: 260px;
  min-width: 260px;
  height: 320px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 0 0 auto;
  cursor: pointer;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.blog-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  transform: translateY(-6px);
}

/* Blog Image */
.blog-card-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #f9f9f9;
  pointer-events: none;
  display: block;
}

/* Blog Content */
.blog-card-content {
  padding: 12px 12px 8px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  justify-content: space-between;
  overflow: hidden;
}

/* Blog Title */
.blog-title {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 2px;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

/* Blog Description */
.blog-description {
  font-size: 12.7px;
  color: #444;
  line-height: 1.45;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 35px;
  margin-bottom: 8px;
  pointer-events: none;
}

/* Blog Meta Info (Author, Likes, Views) */
.blog-meta {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #444;
  gap: 6px;
  margin: 2px 0 6px 0;
  cursor: pointer;
}

/* Author Image */
.blog-author-image {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 4px;
  object-fit: cover;
  border: 1px solid #eee;
  pointer-events: none;
}

/* Author Icon (Fallback) */
.blog-author-icon {
  font-size: 19px;
  margin-right: 5px;
  color: #c0c0c0;
  pointer-events: none;
}

/* Author Name */
.blog-author-name {
  font-weight: 500;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}

/* Likes Count */
.blog-likes {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  pointer-events: none;
}

.blog-likes i {
  color: #f0ad4e;
  margin-right: 2px;
}

/* Views Count */
.blog-views {
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  pointer-events: none;
}

.blog-views i {
  color: #5bc0de;
  margin-right: 2px;
}

/* See More Button */
.blog-see-more-btn {
  width: 100%;
  font-size: 13px;
  margin-top: 0;
  background: #0084d9;
  color: white;
  border: none;
  padding: 8px 0;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.blog-see-more-btn:hover {
  background: #0073bf;
}

/* Empty State */
.blog-empty-state {
  text-align: center;
  width: 100%;
  padding: 20px 0;
}

.blog-empty-state p {
  color: #6c757d;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .blog-card {
    width: 240px;
    min-width: 240px;
    height: 300px;
  }
  
  .blog-title {
    font-size: 14px;
  }
  
  .blog-description {
    font-size: 11px;
  }
}

@media (max-width: 576px) {
  .blog-scroll-row {
    padding: 5px;
    gap: 10px;
  }
  
  .blog-card {
    width: 220px;
    min-width: 220px;
    height: 280px;
  }
}
/* ==========================================================
   SPECIALITIES SECTION
   ========================================================== */

.speciality-img {
  width: 120px;
  height: 120px;
  object-fit: scale-down;
  border-radius: 50%;
  background: transparent;
  transition: box-shadow 0.3s, transform 0.3s;
  box-shadow: 0 4px 14px rgba(0,0,0,0.17);
  display: block;
  margin: 0 auto;
}

.speciality-img:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.26);
  transform: scale(1.07);
}

.speciality-card {
  box-shadow: none;
}

.speciality-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
  text-align: center;
  display: block;
}

.speciality-scroll-row {
  overflow-x: auto;
  gap: 20px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 10px;
}

.section-specialities {
  position: relative;
  z-index: 1;
  margin-top: 1rem;
}

/* ==========================================================
   APP DOWNLOAD SECTION
   ========================================================== */

.section-app-download {
  padding: 80px 0;
  background: linear-gradient(to right, #A3CFBB);
}

.section-app-download.call-to-action {
  position: relative;
  z-index: 0;
  overflow: hidden;
  padding: 60px 0;
}

.cta-container {
  color: #ffffff;
  position: relative;
  overflow: visible !important;
  border-radius: 2rem;
  padding: 2rem 2rem;
  z-index: 1;
}

/* App Download Content */
.app-download-content h2 {
  font-size: 2.2rem;
  font-weight: 700;
  color: var(--text-dark);
}

.app-download-content p {
  font-size: 1rem;
  color: var(--text-light);
}

.app-download-form .input-group {
  box-shadow: var(--box-shadow);
  border-radius: 8px;
  overflow: hidden;
}

.app-download-form .form-control {
  height: 50px;
  border: 1px solid var(--border-color);
}

.app-download-form .btn {
  background-color: var(--secondary-color);
  color: black;
}

.app-download-stores img {
  height: 50px;
  cursor: pointer;
  transition: transform 0.2s;
}

.app-download-stores img:hover {
  transform: scale(1.05);
}

.app-download-img {
  height: 45px;
  width: auto;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.app-download-img:hover {
  transform: scale(1.1);
}

/* Desktop Download Input */
@media (min-width: 992px) {
  .download-input-wrapper {
    display: flex;
    align-items: center;
    border: 2px solid #000000 !important;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 60px;
    padding: 6px 6px 6px 20px;
    max-width: 480px;
    position: relative;
    z-index: 5;
  }

  .custom-input {
    border: none !important;
    background: transparent !important;
    color: #000000 !important;
    outline: none;
    flex-grow: 1;
    font-size: 16px;
  }

  .custom-submit-btn {
    background-color: transparent !important;
    color: #000000 !important;
    border: 2px solid #000000 !important;
    padding: 12px 35px;
    border-radius: 50px;
    font-weight: 700;
    white-space: nowrap;
    transition: all 0.3s ease;
    cursor: pointer;
  }
}

/* Mobile Download Input */
@media (max-width: 991px) {
  .cta-container {
    text-align: center;
    padding: 3rem 1.5rem;
  }

  .download-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;
    background: transparent !important;
    border: none !important;
    max-width: 100%;
  }

  .custom-input {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid #ffffff !important;
    border-radius: 50px;
    padding: 15px 20px;
    color: white !important;
    text-align: center;
    width: 100%;
    outline: none;
  }

  .custom-submit-btn {
    background-color: transparent !important;
    color: #000000 !important;
    border: 2px solid #000000 !important;
    padding: 12px 35px;
    border-radius: 50px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .app-screen-img {
    margin-top: 30px;
    max-width: 280px;
    position: relative;
    z-index: 2;
    transition: transform 0.5s ease;
    max-width: 250px;
    margin: 20px auto 0;
    display: block;
  }

  .justify-content-lg-start {
    justify-content: center !important;
  }
}

.custom-input::placeholder {
  color: rgba(0, 0, 0, 0.5) !important;
}

.custom-submit-btn:hover {
  background-color: #000000 !important;
  color: #ffffff !important;
  transform: translateY(-3px);
}

@media (min-width: 992px) {
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
}

.app-screen-img {
  height: 330px;
  width: auto;
  object-fit: contain;
}

/* ==========================================================
   FAQ SECTION
   ========================================================== */

.faq {
  padding: 60px 0;
  background-color: #ffffff;
  font-family: "Roboto", sans-serif;
}

.light-background {
  background-color: #f3f9ff !important;
}

.faq .faq-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #2d465e;
  font-family: "Nunito", sans-serif;
}

.faq .faq-description {
  font-size: 1rem;
  color: #212529;
  margin-bottom: 2rem;
}

.faq .faq-arrow {
  color: #198754;
}

.faq .faq-container .faq-item {
  background-color: #ffffff;
  position: relative;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: 0.3s;
  border: 1px solid #e9ecef;
}

.faq .faq-container .faq-item:last-child {
  margin-bottom: 0;
}

.faq .faq-container .faq-item h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin: 0 30px 0 0;
  transition: 0.3s;
  display: flex;
  align-items: center;
  color: #2d465e;
}

.faq .faq-container .faq-item h3:hover {
  color: #198754;
}

.faq .faq-container .faq-item .faq-content {
  display: grid;
  grid-template-rows: 0fr;
  transition: 0.3s ease-in-out;
  visibility: hidden;
  opacity: 0;
}

.faq .faq-container .faq-item .faq-content p {
  margin-bottom: 0;
  overflow: hidden;
  color: #212529;
  font-size: 15px;
  line-height: 1.6;
}

.faq .faq-container .faq-item .faq-toggle {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 16px;
  line-height: 0;
  transition: 0.3s;
  color: #212529;
}

.faq .faq-container .faq-active h3 {
  color: #198754;
}

.faq .faq-container .faq-active .faq-content {
  grid-template-rows: 1fr;
  visibility: visible;
  opacity: 1;
  padding-top: 10px;
}

.faq .faq-container .faq-active .faq-toggle {
  transform: rotate(90deg);
  color: #198754;
}

.faq-arrow svg {
  animation: shapes-float 3s ease-in-out infinite;
  fill: #198754;
  opacity: 0.15;
}

@keyframes shapes-float {
  0%, 100% {
    transform: scale(0.8) rotate(45deg) translateY(0);
  }
  50% {
    transform: scale(0.8) rotate(45deg) translateY(-20px);
  }
}

/* ==========================================================
   BUTTON STYLES
   ========================================================== */

.button-row {
  display: flex;
  justify-content: space-between;
  gap: 3px;
  width: 100%;
}

.view-button {
  /* Add your view button styles here */
}

/* ==========================================================
   SKELETON LOADING
   ========================================================== */

.skeleton {
  background-color: #f0f0f0;
  position: relative;
  overflow: hidden;
  border-color: transparent !important;
}

.skeleton::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  100% {
    left: 150%;
  }
}

.skeleton-img {
  width: 100%;
  background-color: #e9ecef;
  aspect-ratio: 4 / 3;
}

.skeleton-line {
  background-color: #e9ecef;
  border-radius: 4px;
}

/* ==========================================================
   CHAT LOGO
   ========================================================== */

.chat_logo {
  position: fixed;
  right: -10px;
  bottom: -50px;
  z-index: 1000;
  width: 100px;
  height: 100px;
}

.chat_logo img {
  width: 50px;
  height: 50px;
}

/* ==========================================================
   CAROUSEL WRAPPER
   ========================================================== */

.carousel-wrapper {
  position: relative;
  width: 75%;
  max-width: 1500px;
  margin: 0 auto;
}

.carousel-arrow {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
}

/* ==========================================================
   RESPONSIVE UTILITIES
   ========================================================== */

.section-header-mm {
  padding-left: 15px;
  padding-right: 15px;
}

@media (max-width: 576px) {
  .container,
  .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: 100% !important;
  }

  .offer-scroll-row {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .main-width-wrapper {
    width: auto !important;
    max-width: none !important;
    margin-left: 48px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .offer-card img, 
  .blog-card img, 
  .doctor-card img {
    pointer-events: none;
    user-drag: none;
    -webkit-user-drag: none;
  }

  .active-dragging {
    scroll-behavior: auto !important;
  }

  .active-dragging a, 
  .active-dragging button {
    pointer-events: none;
  }
}

@media (max-width: 991px) {
  .doctors-carousel-arrow {
    display: none;
  }

  .section-header-doctors {
    text-align: center;
  }

  .section-header-doctors p, 
  .feature-list {
    margin-left: auto;
    margin-right: auto;
  }

  .text-white-50 {
    color: rgba(255, 255, 255, 0.8) !important;
  }
}

/* ==========================================================
   DRAGGABLE SCROLL UTILITIES
   ========================================================== */

.active-dragging {
  scroll-behavior: auto !important;
}

.active-dragging a, 
.active-dragging button {
  pointer-events: none;
}

        `}
      </style>

      <section
        className="section section-search content pt-5 mt-5"
        style={{ minHeight: "350px" }}
      >
        <CContainer className="cta-container">
          <div className="shape shape-1">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M47.1,-57.1C59.9,-45.6,68.5,-28.9,71.4,-10.9C74.2,7.1,71.3,26.3,61.5,41.1C51.7,55.9,35,66.2,16.5,69.2C-2,72.2,-22.3,67.9,-38.8,57.9C-55.3,47.9,-67.9,32.2,-72.2,14.5C-76.5,-3.1,-72.5,-22.7,-61.7,-36.6C-50.9,-50.5,-33.2,-58.8,-15.8,-62.1C1.6,-65.4,19.1,-63.7,34.3,-58.4C40.1,-56.3,44.2,-50.7,47.1,-57.1Z"
                transform="translate(100 100)"
              />
            </svg>
          </div>
          <div className="shape shape-2">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M41.3,-49.1C54.4,-39.3,66.6,-28.7,71.1,-15.3C75.6,-1.9,72.4,14.4,63.8,27.1C55.2,39.8,41.1,49,26.1,54.3C11.1,59.5,-4.8,60.8,-21,57.5C-37.2,54.2,-53.7,46.2,-62.1,32.8C-70.5,19.4,-70.8,0.5,-65.4,-15.8C-60,-32,-48.9,-45.6,-35.3,-55.2C-21.7,-64.8,-5.6,-70.4,7.8,-68.8C21.2,-67.2,33.1,-58.4,41.3,-49.1Z"
                transform="translate(100 100)"
              />
            </svg>
          </div>
          <div className="dots dots-1">
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <pattern
                id="dot-pattern-1"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              </pattern>
              <rect width="100" height="100" fill="url(#dot-pattern-1)"></rect>
            </svg>
          </div>
          <div className="dots dots-2">
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <pattern
                id="dot-pattern-2-unique"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              </pattern>
              <rect
                width="100"
                height="100"
                fill="url(#dot-pattern-2-unique)"
              ></rect>
            </svg>
          </div>

          <div className="text-center position-relative" style={{ zIndex: 10 }}>
            <h2
              className="text-black fw-bold mb-4"
              style={{ fontSize: "1.8rem" }}
            >
              Health Insurance
            </h2>
            <div className="custom-search-bar mb-4">
              {/* INSURANCE FILTERS */}
              <div className="filter-badge-group mb-4">
                <div
                  className={`filter-badge-item ${insuranceFilters.health ? "active" : ""}`}
                  onClick={() => toggleInsuranceFilter("health")}
                >
                  <div className="small-checkbox-box">
                    {insuranceFilters.health && (
                      <i className="fas fa-check"></i>
                    )}
                  </div>
                  <span className="filter-badge-text">Health Plans</span>
                </div>

                <div
                  className={`filter-badge-item ${insuranceFilters.family ? "active" : ""}`}
                  onClick={() => toggleInsuranceFilter("family")}
                >
                  <div className="small-checkbox-box">
                    {insuranceFilters.family && (
                      <i className="fas fa-check"></i>
                    )}
                  </div>
                  <span className="filter-badge-text">Family Cover</span>
                </div>

                <div
                  className={`filter-badge-item ${insuranceFilters.senior ? "active" : ""}`}
                  onClick={() => toggleInsuranceFilter("senior")}
                >
                  <div className="small-checkbox-box">
                    {insuranceFilters.senior && (
                      <i className="fas fa-check"></i>
                    )}
                  </div>
                  <span className="filter-badge-text">Senior Citizen</span>
                </div>
              </div>

              {/* SEARCH BAR */}
              <form onSubmit={handleSearch}>
                <div className="search-container-custom">
                  <div className="search-input-wrapper">
                    <i className="fas fa-map-marker-alt input-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Location..."
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                    />
                  </div>

                  <div className="search-input-wrapper">
                    <i className="fas fa-search input-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search insurance plans..."
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn-custom-search btn-white-download"
                    style={{ height: "45px" }}
                  >
                    SEARCH
                  </button>
                </div>
              </form>
            </div>

            <p
              className="text-white mx-auto mb-2"
              style={{ maxWidth: "700px", fontSize: "1.1rem", opacity: 0.9 }}
            >
              Protect your family's future with our upcoming Health Insurance
              plans. We are partnering with top providers to give you the best
              coverage.
            </p>
          </div>
        </CContainer>
      </section>
      <NavStrip />
      <OfferSection />
      <BlogSection />
      <FaqSection />
      <DownloadSection />
    </div>
  );
};
export default HealthInsurance;
